(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mettle-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mettle-hero')) {
    class MettleHero extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        const cfgEl = this.querySelector('[data-mh-config]');
        if (!cfgEl) return;
        this._ready = true;
        this.cfg = JSON.parse(cfgEl.textContent);
        this.product = this.cfg.product;
        const decoder = document.createElement('textarea');
        decoder.innerHTML = this.cfg.moneyFormat;
        this.moneyFormat = decoder.value;

        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.qtyInput = this.querySelector('[data-mh-qty-input]');
        this.atcBtn = this.querySelector('[data-mh-atc]');
        this.atcText = this.querySelector('[data-mh-atc-text]');
        this.buyBtn = this.querySelector('[data-mh-buy]');
        this.errorEl = this.querySelector('[data-mh-error]');
        this.groups = Array.from(this.querySelectorAll('[data-mh-option]'));

        this.groups.forEach((g) => g.addEventListener('change', () => this.update(false)));
        this.querySelectorAll('[data-mh-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const next = (parseInt(this.qtyInput.value, 10) || 1) + parseInt(btn.dataset.mhQty, 10);
            this.qtyInput.value = Math.max(1, next);
            if (this.variant) this.renderPrice(this.variant);
          });
        });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.addToCart(); });
        if (this.buyBtn) {
          this.buyBtn.addEventListener('click', () => this.buyNow());
          window.addEventListener('pageshow', () => this.setLoading(this.buyBtn, false));
        }
        this.update(true);
      }

      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      qty() { return Math.max(1, parseInt(this.qtyInput && this.qtyInput.value, 10) || 1); }

      selection() {
        return this.groups.map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
      }

      find(sel) {
        return this.product.variants.find((v) => sel.every((val, i) => v.options[i] === val)) || null;
      }

      money(cents) {
        const re = /\{\{\s*(\w+)\s*\}\}/;
        const m = this.moneyFormat.match(re);
        const type = m ? m[1] : 'amount';
        const num = (dec, th, ds) => {
          const p = (cents / 100).toFixed(dec).split('.');
          p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
          return p.length > 1 ? p[0] + ds + p[1] : p[0];
        };
        let val;
        switch (type) {
          case 'amount_no_decimals': val = num(0, ',', '.'); break;
          case 'amount_with_comma_separator': val = num(2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': val = num(0, '.', ','); break;
          case 'amount_with_apostrophe_separator': val = num(2, "'", '.'); break;
          default: val = num(2, ',', '.');
        }
        if (this.cfg.hideDecimals) val = val.replace(/[.,]00$/, '');
        return this.moneyFormat.replace(re, val);
      }

      update(initial) {
        const sel = this.selection();
        const variant = this.find(sel);
        if (!variant) {
          const fb = this.fallback(sel);
          if (fb) { this.applyOptions(fb.options); return this.update(initial); }
        }
        this.refreshPills(sel);
        this.updatePreviews();
        this.hideError();
        if (!variant) {
          this.variant = null;
          this.setButtons(false, this.cfg.unavailableText);
          return;
        }
        this.variant = variant;
        this.idInput.value = variant.id;
        this.renderPrice(variant);
        this.setButtons(variant.available, variant.available ? this.cfg.atcText : this.cfg.soldOutText);

        const img = this.querySelector('[data-mh-figure] img');
        if (initial) {
          if (img && this.cfg.images) img.dataset.current = this.cfg.images[variant.id] || '';
          return;
        }
        this.swapImage(variant, img);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      fallback(sel) {
        for (let skip = sel.length - 1; skip >= 0; skip--) {
          const cands = this.product.variants.filter((v) => sel.every((val, i) => i === skip || v.options[i] === val));
          if (cands.length) return cands.find((v) => v.available) || cands[0];
        }
        return null;
      }

      applyOptions(opts) {
        this.groups.forEach((g) => {
          const idx = parseInt(g.dataset.mhOption, 10);
          g.querySelectorAll('input').forEach((inp) => { inp.checked = inp.value === opts[idx]; });
        });
      }
      updatePreviews() {
        this.groups.forEach((group) => {
          const pv = group.querySelector('[data-mh-preview]');
          if (!pv) return;
          const c = group.querySelector('input:checked');
          const lab = c && group.querySelector('label[for="' + c.id + '"]');
          if (!lab || !group.querySelector('.mh__swatch')) { pv.hidden = true; return; }
          pv.hidden = false;
          pv.style.setProperty('--fc', lab.style.getPropertyValue('--fc') || '');
          pv.innerHTML = '';
          const sm = document.createElement('small');
          sm.textContent = 'Selected flavour';
          const b = document.createElement('b');
          b.textContent = c.value;
          pv.appendChild(sm);
          pv.appendChild(b);
        });
      }
      refreshPills(sel) {
        this.groups.forEach((group) => {
          const idx = parseInt(group.dataset.mhOption, 10);
          group.querySelectorAll('input').forEach((input) => {
            const candidate = sel.slice();
            candidate[idx] = input.value;
            const match = this.find(candidate);
            const pill = input.closest('.mh__pill');
            const prefixOk = (v) => v.options[idx] === input.value && sel.slice(0, idx).every((val, i) => v.options[i] === val);
            const exists = this.product.variants.some(prefixOk);
            const anyAvail = this.product.variants.some((v) => prefixOk(v) && v.available);
            pill.classList.toggle('is-missing', !exists);
            pill.classList.toggle('is-unavailable', exists && (match ? !match.available : !anyAvail));
            const priceEl = pill.querySelector('[data-mh-pill-price]');
            if (priceEl) {
              const pv = match || this.product.variants.find((v) => v.options[idx] === input.value);
              if (pv) priceEl.textContent = this.money(pv.price);
            }
          });
        });
      }

      renderPrice(v) {
        const q = this.qty();
        const price = this.querySelector('[data-mh-price]');
        const compare = this.querySelector('[data-mh-compare]');
        const save = this.querySelector('[data-mh-save]');
        price.textContent = this.money(v.price * q);
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        compare.hidden = !onSale;
        save.hidden = !onSale;
        if (!onSale) return;
        const diff = (v.compare_at_price - v.price) * q;
        compare.textContent = this.money(v.compare_at_price * q);
        save.textContent = this.cfg.saveText
          .replace('[amount]', this.money(diff))
          .replace('[percent]', Math.round((diff * 100) / (v.compare_at_price * q)));
      }

      setButtons(available, label) {
        this.atcBtn.disabled = !available;
        this.atcText.textContent = label;
        if (this.buyBtn) this.buyBtn.disabled = !available;
      }

      swapImage(v, img) {
        const url = this.cfg.images && this.cfg.images[v.id];
        if (!url || !img || img.dataset.current === url) return;
        img.dataset.current = url;
        const srcset = [500, 900, 1400]
          .map((w) => `${url.replace(/([?&])width=\d+/, `$1width=${w}`)} ${w}w`)
          .join(', ');
        img.style.opacity = '0';
        const next = new Image();
        next.sizes = img.sizes;
        next.onload = () => {
          if (img.dataset.current !== url) return;
          img.srcset = srcset;
          img.src = url;
          img.style.opacity = '1';
        };
        next.onerror = () => { img.style.opacity = '1'; };
        next.srcset = srcset;
        next.src = url;
      }

      setLoading(btn, on) {
        if (!btn) return;
        btn.classList.toggle('is-loading', on);
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
        btn.disabled = on || !(this.variant && this.variant.available);
      }

      showError(msg) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
      hideError() { if (this.errorEl) this.errorEl.hidden = true; }

      async addToCart() {
        if (!this.variant || !this.variant.available) return;
        this.hideError();
        this.setLoading(this.atcBtn, true);
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const fd = new FormData();
        fd.append('id', this.variant.id);
        fd.append('quantity', this.qty());
        const canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
        if (canRender) {
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        try {
          const res = await fetch(`${this.root()}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd,
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
          if (!canRender) {
            window.location.href = `${this.root()}cart`;
            return;
          }
          cart.renderContents(data);
          cart.classList.remove('is-empty');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mettle-hero', productVariantId: this.variant.id, cartData: data });
          }
        } catch (err) {
          this.showError(err.message || 'This item could not be added to your cart. Refresh the page and try again.');
        } finally {
          this.setLoading(this.atcBtn, false);
        }
      }
            showMedia(btn) {
        const img = this.querySelector('[data-mh-figure] img');
        if (!img) return;
        const url = btn.dataset.full;
        img.dataset.current = url;
        img.removeAttribute('srcset');
        img.src = url;
        this.querySelectorAll('.mh__thumb').forEach((t) => t.classList.toggle('is-active', t === btn));
      }
      async buyNowCart() {
        if (!this.variant || !this.variant.available) return;
        const btn = this.querySelector('.mh__btn--buy');
        this.hideError();
        this.setLoading(btn, true);
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const fd = new FormData();
        fd.append('updates[' + this.variant.id + ']', this.qty());
        const canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
        if (canRender) {
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
        }
        try {
          const res = await fetch(`${this.root()}cart/update.js`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd,
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message || 'Could not update your cart.');
          if (!canRender) { window.location.href = `${this.root()}cart`; return; }
          cart.renderContents(data);
          cart.classList.remove('is-empty');
        } catch (err) {
          this.showError(err.message || 'Could not update your cart. Refresh the page and try again.');
        } finally {
          this.setLoading(btn, false);
        }
      }     
      buyNow() {
        if (!this.variant || !this.variant.available) return;
        this.setLoading(this.buyBtn, true);
        window.location.href = `${this.root()}cart/${this.variant.id}:${this.qty()}`;
      }
    }
    customElements.define('mettle-hero', MettleHero);
  }

  } catch(e) { console.error(e); }
})();
})();
